import React from "react";

export let UserContext = React.createContext({});
export let MediaContext = React.createContext({});
